import PropTypes from "prop-types"
import React from "react"
import { Modal, Grid, Button } from "semantic-ui-react"
import "./ConfirmProposalRequest.css"
import { Loader } from "uikit"

export default class ConfirmProposalRequest extends React.Component {
  static propTypes = {
    onYes: PropTypes.func.isRequired,
    onNo: PropTypes.func.isRequired,
    onConflict: PropTypes.func.isRequired,
    header: PropTypes.string,
    contentText: PropTypes.string,
    yesTextLabel: PropTypes.string,
    noTextLabel: PropTypes.string
  }

  static defaultProps = {
    header: "Are you sure?",
    yesTextLabel: "Yes",
    noTextLabel: "No",
    contentText:
      "Are you sure you want to update your plan now, it may take a while?"
  }

  constructor(props) {
    super(props)
    this.state = {
      pending: false
    }
  }
  onNo = () => {
    this.setState({ pending: true })
    this.props.onNo()
  }
  onRequestProposal = async () => {
    this.setState({ pending: true })
    const { scenario, requestProposal } = this.props
    const response = await requestProposal(scenario.id)
    if (response.error) {
      if (typeof this.props.onConflict === "function") {
        this.props.onConflict()
      } else {
        this.onNo()
        this.setState({ pending: false })
      }
    } else {
      this.props.onYes()
      this.setState({ pending: false })
    }
  }
  render = () => {
    const { header, contentText, yesTextLabel, noTextLabel } = this.props
    const Trigger = this.state.trigger
    const triggerProp = Trigger ? { trigger: <Trigger /> } : {}

    return (
      <Modal
        defaultOpen={!Trigger}
        className="AskForConfirmation"
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
        {...triggerProp}
      >
        <Modal.Header style={{ fontWeight: "300" }}>{header}</Modal.Header>
        <Modal.Content>
          <p>{contentText}</p>
          <Loader active={this.state.pending} text="" />
        </Modal.Content>
        <Modal.Actions>
          <Grid>
            <Grid.Row columns="equal">
              <Grid.Column textAlign="left">
                <Button
                  content={noTextLabel}
                  color="red"
                  fluid
                  onClick={this.onNo}
                  disabled={this.state.pending}
                />
              </Grid.Column>
              <Grid.Column textAlign="right">
                <Button
                  content={yesTextLabel}
                  primary
                  fluid
                  onClick={this.onRequestProposal}
                  disabled={this.state.pending}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Actions>
      </Modal>
    )
  }
}
